import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function addBellMsg(data) {
  return request({
    url: URL.sys.addBellMsg,
    method: 'post',
    data
  })
}

export function updateBellMsg(data) {
  return request({
    url: URL.sys.updateBellMsg,
    method: 'put',
    data
  })
}

export function removeBellMsg(data) {
  return request({
    url: URL.sys.removeBellMsg,
    method: 'delete',
    data
  })
}

export function getBellMsg(data) {
  return request({
    url: URL.sys.getBellMsg,
    method: 'get',
    data
  })
}

export function pageBellMsg(data) {
  return request({
    url: URL.sys.pageBellMsg,
    method: 'post',
    data
  })
}

export function checkBellMsg(data) {
  return request({
    url: URL.sys.checkBellMsg,
    method: 'get',
    data
  })
}

